module.exports = __webpack_public_path__ + "static/media/protDF.16a28046.png";